import { render } from "./newFiveMuseum.vue?vue&type=template&id=610f614c&scoped=true"
import script from "./newFiveMuseum.vue?vue&type=script&lang=js"
export * from "./newFiveMuseum.vue?vue&type=script&lang=js"

import "./newFiveMuseum.vue?vue&type=style&index=0&id=610f614c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f614c"]])

export default __exports__